<template lang="">
    <div>
        <h1 style="height:100vh">PageOne</h1>
    </div>
</template>
<script>
export default {
    data() {
        return {

        }
    },
}
</script>
<style lang="">
    
</style>